import { render, staticRenderFns } from "./DatacenterGJ.vue?vue&type=template&id=7626bb53&scoped=true"
import script from "./DatacenterGJ.vue?vue&type=script&lang=js"
export * from "./DatacenterGJ.vue?vue&type=script&lang=js"
import style0 from "./DatacenterGJ.vue?vue&type=style&index=0&id=7626bb53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7626bb53",
  null
  
)

export default component.exports